// Identifiant persistant de navigateur (anti-triche parrainage)
export function getVid() {
  try {
    let v = localStorage.getItem("ant_vid");
    if (!v) {
      v = "vid_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem("ant_vid", v);
    }
    return v;
  } catch {
    return "";
  }
}
